/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchRuleDelete
 */
export interface SearchRuleDelete {
    /**
     * 
     * @type {string}
     * @memberof SearchRuleDelete
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchRuleDelete
     */
    deleted?: boolean;
}

export function SearchRuleDeleteFromJSON(json: any): SearchRuleDelete {
    return SearchRuleDeleteFromJSONTyped(json, false);
}

export function SearchRuleDeleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRuleDelete {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
    };
}

export function SearchRuleDeleteToJSON(value?: SearchRuleDelete | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'deleted': value.deleted,
    };
}


